
<error-error-content 
  image="assets/img/images/error-images/image2.png"
  errorType="AUTHORIZATION_NEEDED"
  copy="ERROR_401"></error-error-content>

